import { render, staticRenderFns } from "./table-settings.vue?vue&type=template&id=2e4dd7ab&scoped=true&"
import script from "./table-settings.vue?vue&type=script&lang=js&"
export * from "./table-settings.vue?vue&type=script&lang=js&"
import style0 from "./table-settings.vue?vue&type=style&index=0&id=2e4dd7ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4dd7ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e4dd7ab')) {
      api.createRecord('2e4dd7ab', component.options)
    } else {
      api.reload('2e4dd7ab', component.options)
    }
    module.hot.accept("./table-settings.vue?vue&type=template&id=2e4dd7ab&scoped=true&", function () {
      api.rerender('2e4dd7ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/table-settings.vue"
export default component.exports